// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.switch__wrapper__title {
  font-size: var(--subheader);
}`, "",{"version":3,"sources":["webpack://./src/components/Switch/SwitchCustom.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B","sourcesContent":[".switch__wrapper__title {\n  font-size: var(--subheader);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
